/**
 * Vendor Model Interface
 * Framework-agnostic TypeScript interface
 */

export interface Vendor {
  id?: number;
  vendor_id?: number;
  vendor_name: string;
  vendor_code?: string;
  contact_person?: string;
  contact_email?: string;
  contact_phone?: string;
  address?: string;
  city?: string;
  state?: string;
  country?: string;
  created_at?: string;
  updated_at?: string;
  active?: number | boolean;
  program_id?: number;
}

export interface VendorApiResponse {
  data: {
    vendors: Vendor[];
  };
  message?: string;
  success?: boolean;
}
